import { createContext, useContext } from "react";

import type { AppliedConfigContextValue } from "./types";

export const AppliedConfigContext = createContext<
  AppliedConfigContextValue | undefined
>(undefined);

export const useAppliedConfigContext = (): AppliedConfigContextValue => {
  const context = useContext(AppliedConfigContext);

  if (!context) {
    throw new Error(
      "useAppliedConfigContext must be used within an AppliedConfigProvider",
    );
  }

  return context;
};
